import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { LayoutService, WidthState } from '@shared/services/layout.service';
import { Destroyer } from '@shared/utils';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[ifWidth]'
})
export class BreakpointsDirective extends Destroyer implements OnInit {

  private currentWidth: WidthState;
  private expected: WidthState[] = [];
  private exist: boolean;

  constructor(
    private layout: LayoutService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    super();
  }

  @Input() set ifWidth(width: WidthState | WidthState[]) {
    this.expected = Array.isArray(width) ? width : [width];
    this.updateView();
  }

  ngOnInit() {
    this.layout.width$
      .pipe(takeUntil(this.destroy$))
      .subscribe(width => {
        this.currentWidth = width;
        this.updateView();
      });
    }

  private updateView() {
    if (this.check()) {
        if (!this.exist) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.exist = true;
        }
    } else {
      this.viewContainer.clear();
      this.exist = false;
    }
  }

  private check() {
    // console.log({ current: this.currentWidth, expected: this.expected })
    return this.expected.includes(this.currentWidth);
  }

}
